export interface Comment {
    caption: string;
    comment: string;
}
